import React, { useEffect, useState } from "react"; // Added useState for email
import { useParams, Link } from "react-router-dom";
import "./BlogPost.css";

// Import blog post components
import AIWithoutEmotions from "../Blog/posts/AIWithoutEmotions";
import FutureOfAILeadership from "../Blog/posts/FutureOfAILeadership";
import RiseOfAgenticAi from "../Blog/posts/RiseOfAgenticAi";
import OpenAiDevTools from "../Blog/posts/OpenAiDevTools";
import OpenAiDevToolsDown from "../Blog/posts/OpenAiDevToolsDown";
import AIShortcutTrap from "../Blog/posts/AIShortcutTrap";

const blogPosts = {
  "ai-without-emotions": AIWithoutEmotions,
  "future-of-ai-leadership": FutureOfAILeadership,
  "rise-of-agentic-ai": RiseOfAgenticAi,
  "openai-developer-tools": OpenAiDevTools,
  "openai-dev-tools-down": OpenAiDevToolsDown,
  "ai-shortcut-trap": AIShortcutTrap,
};

function BlogPost() {
  const { id } = useParams();
  const [email, setEmail] = useState(""); // Email state for subscription

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Optional: adds smooth scrolling
    });
  }, [id]); // Ensure it scrolls when the blog post changes

  if (!blogPosts[id]) {
    return (
      <div className="blog-post-not-found">
        <h2>Post not found</h2>
        <Link to="/blog" className="back-to-blog">
          Back to Blog
        </Link>
      </div>
    );
  }

  const { metadata, Content } = blogPosts[id];

  // Email Validation & Submission Logic (Same as in Blog.js)
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const sanitizeEmail = (email) => {
    return email.replace(/[<>/'";(){}]/g, ""); // Strips dangerous characters
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let sanitizedEmail = sanitizeEmail(email);

    if (!validateEmail(sanitizedEmail)) {
      alert("Invalid email format. Please enter a valid email.");
      return;
    }

    fetch(
      "https://script.google.com/macros/s/AKfycbwLBUY2t-JeSkfULYXAd3yX-Fsp_r7T-_vyeZKKKQqFSTeFgzeHAgZ1a2O6DV9EdVg/exec",
      {
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: sanitizedEmail }),
      }
    )
      .then(() => {
        alert("Subscribed successfully!");
        setEmail("");
      })
      .catch((error) => {
        console.error("Error:", error);
        alert("Subscription failed, please try again.");
      });
  };

  return (
    <>
      <header className="header">
        <h1 className="header-title">{metadata.title}</h1>
      </header>
      <div className="blog-post-container">
        <div className="blog-post-meta">
          <span className="post-date">{metadata.date}</span>
          {metadata.author && (
            <span className="post-author">By {metadata.author}</span>
          )}
        </div>

        <div className="blog-post-hero">
          <img
            src={metadata.image}
            alt={metadata.title}
            className="blog-post-image"
          />
        </div>

        <div className="blog-post-content">
          <Content />
        </div>

        {/* 🚀 Call-to-Action: Newsletter Signup at the End of Every Blog Post */}
        <section className="newsletter-section">
          <div className="container">
            <div className="newsletter-container">
              <h3>Stay Updated</h3>
              <p>
                Get the latest insights on AI and automation delivered to your
                inbox.
              </p>
              <form className="newsletter-form" onSubmit={handleSubmit}>
                <input
                  type="email"
                  placeholder="Your email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <button type="submit">Subscribe</button>
              </form>
            </div>
          </div>
        </section>

        <div className="blog-post-navigation">
          <Link to="/blog" className="back-to-blog">
            ← Back to Blog
          </Link>
        </div>
      </div>
    </>
  );
}

export default BlogPost;
